import { render, staticRenderFns } from "./Listar.vue?vue&type=template&id=2dc86857&scoped=true&"
import script from "./Listar.vue?vue&type=script&lang=ts&"
export * from "./Listar.vue?vue&type=script&lang=ts&"
import style0 from "./Listar.vue?vue&type=style&index=0&id=2dc86857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc86857",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
